import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/** 四个资金账户明细页的切换定义 */
const accounts = [
  { key: 'voucher', label: '代金券账户', title: '代金券明细', icon: 'ri-wallet-3-line', path: '/voucher-details' },
  { key: 'coupon', label: '优惠券账户', title: '优惠券明细', icon: 'ri-ticket-line', path: '/coupon-details' },
  { key: 'bonus', label: '奖金账户', title: '奖金明细', icon: 'ri-coin-line', path: '/bonus-details' },
  { key: 'commission', label: '推广账户', title: '推广佣金明细', icon: 'ri-share-forward-line', path: '/commission-details' },
] as const;

export type AccountKey = (typeof accounts)[number]['key'];

interface Props {
  current: AccountKey;
}

/**
 * 资金明细页共享头部：左上角返回个人中心，右上角弹出账户切换菜单
 */
export default function AccountSwitchHeader({ current }: Props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const active = accounts.find((a) => a.key === current) || accounts[0];

  const handleSelect = (key: AccountKey, path: string) => {
    setOpen(false);
    if (key !== current) navigate(path);
  };

  return (
    <header className="sticky top-0 z-20 bg-white/90 backdrop-blur-sm border-b border-background-100">
      <div className="flex items-center justify-between px-4 py-3.5">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/profile')}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="返回个人中心"
          >
            <i className="ri-arrow-left-s-line text-xl text-foreground-700"></i>
          </button>
          <h1 className="text-base font-semibold text-foreground-900">{active.title}</h1>
        </div>

        {/* 账户切换 */}
        <div className="relative">
          <button
            onClick={() => setOpen((v) => !v)}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className={`${active.icon} text-sm text-foreground-600`}></i>
            <span className="text-xs font-medium text-foreground-600">{active.label}</span>
            <i className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-xs text-foreground-500`}></i>
          </button>

          {open && (
            <>
              {/* 遮罩：点击收起 */}
              <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
              <div className="absolute right-0 top-full mt-2 z-20 w-40 bg-white rounded-xl shadow-lg border border-background-200/60 py-1.5 overflow-hidden">
                {accounts.map((a) => (
                  <button
                    key={a.key}
                    onClick={() => handleSelect(a.key, a.path)}
                    className={`w-full flex items-center gap-2 px-3.5 py-2.5 text-xs cursor-pointer transition-colors ${
                      a.key === current
                        ? 'text-primary-600 bg-primary-50 font-medium'
                        : 'text-foreground-600 hover:bg-background-100'
                    }`}
                  >
                    <i className={`${a.icon} text-sm`}></i>
                    <span className="flex-1 text-left">{a.label}</span>
                    {a.key === current && <i className="ri-check-line text-sm"></i>}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
